import { render, staticRenderFns } from "./goldSun_router.vue?vue&type=template&id=405f4ab4&scoped=true"
import script from "./goldSun_router.vue?vue&type=script&lang=js"
export * from "./goldSun_router.vue?vue&type=script&lang=js"
import style0 from "./goldSun_router.vue?vue&type=style&index=0&id=405f4ab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f4ab4",
  null
  
)

export default component.exports